import { DangerAlert } from "components/common/Alerts";
import { Breadcrumb, BreadcrumbLink } from "components/common/Breadcrumb";
import ContentLoading from "components/common/ContentLoading";
import RoleName from "enums/RoleName";
import TaxConfiguration from "interfaces/TaxConfiguration";
import * as React from "react";
import { RouteComponentProps } from "react-router";
import MaskedInput from "react-text-mask";
import apifetch from "utils/apifetch";
import createNumberMask from "utils/createNumberMask";
import extractErrorMessage from "utils/extractErrorMessage";
import isInRole from "utils/isInRole";
import normalizePercentage from "utils/normalizePercentage";
import "./Tax.css";

interface State {
    isLoading: boolean;
    isSubmitting: boolean;
    hasValidationErrors: boolean;
    errorMessage?: string;
    data: TaxConfiguration;
    salesTaxRate: string;
}

export default class Tax extends React.Component<
    RouteComponentProps<{}>,
    State
> {
    constructor(props: RouteComponentProps<{}>) {
        super(props);

        this.state = {
            isLoading: true,
            isSubmitting: false,
            hasValidationErrors: false,
            errorMessage: undefined,
            data: {} as any,
            salesTaxRate: "",
        };

        this.handlePercentageInputChanged =
            this.handlePercentageInputChanged.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        if (this.state.isLoading) {
            return (
                <div className="container">
                    <ContentLoading />
                </div>
            );
        }

        const percentageMask = createNumberMask({
            prefix: "",
            suffix: "%",
            allowDecimal: true,
            decimalLimit: 4,
        });

        return (
            <div className="container settings-tax">
                <div className="animated fadeIn">
                    <Breadcrumb>
                        <BreadcrumbLink to="/">Home</BreadcrumbLink>
                        <BreadcrumbLink to="/settings">Settings</BreadcrumbLink>
                        <BreadcrumbLink isActive={true}>Tax</BreadcrumbLink>
                    </Breadcrumb>
                    {this.state.hasValidationErrors && (
                        <DangerAlert name="dangerAlert">
                            {this.state.errorMessage || "An error occurred."}
                        </DangerAlert>
                    )}
                    <form onSubmit={this.handleSubmit}>
                        <div className="box">
                            <div className="row">
                                <div className="field-group col-sm-6">
                                    <span className="field-label">Default Sales Tax Rate</span>
                                    <MaskedInput
                                        mask={percentageMask}
                                        name="defaultSalesTaxRate"
                                        className="form-control"
                                        onChange={this.handlePercentageInputChanged}
                                        defaultValue={this.state.salesTaxRate}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="form-actions">
                            <div className="text-center">
                                {this.state.isSubmitting ? (
                                    <button type="submit" className="btn btn-primary" disabled>
                                        <i className="icon-spinner icon-pulse"></i> Saving
                                    </button>
                                ) : (
                                    <button type="submit" className="btn btn-primary">
                                        Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }

    public componentWillMount() {
        if (isInRole(RoleName.Admin)) {
            return true;
        }

        this.props.history.push("/settings");
        return false;
    }

    public async componentDidMount() {
        if (this.state.isLoading) {
            let response = await apifetch("settings/tax", undefined, true);
            if (response.ok) {
                let data = (await response.json()) as TaxConfiguration;
                this.setState({
                    isLoading: false,
                    data: data,
                    salesTaxRate: (data.defaultSalesTaxRate * 100).toString(),
                });

                document.title = "Tax Settings - " + SITE_NAME;
            } else {
                const errorText = await extractErrorMessage(response);
                this.setState({
                    isLoading: false,
                    hasValidationErrors: true,
                    errorMessage: errorText,
                });
            }
        }
    }

    private handlePercentageInputChanged(
        event: React.ChangeEvent<HTMLInputElement>
    ) {
        let currentTarget = event.currentTarget;

        this.setState((prevState) => ({
            data: {
                ...prevState.data,
                [currentTarget.name]:
                    (parseFloat(normalizePercentage(currentTarget.value)!) || 0) / 100,
            },
        }));
    }

    private async handleSubmit(event: React.FormEvent<HTMLFormElement>) {
        event.preventDefault();

        this.setState({
            isSubmitting: true,
            hasValidationErrors: false,
            errorMessage: undefined,
        });

        let response = await apifetch(
            "settings/tax",
            {
                headers: new Headers({
                    Accept: "application/json",
                    "Content-Type": "application/json",
                }),
                method: "PUT",
                body: JSON.stringify(this.state.data),
            },
            true
        );
        if (response.ok) {
            this.props.history.push("/settings");
        } else {
            const errorText = await extractErrorMessage(response);
            this.setState({
                isSubmitting: false,
                hasValidationErrors: true,
                errorMessage: errorText,
            });
        }
    }
}



// WEBPACK FOOTER //
// ./ClientApp/components/settings/Tax.tsx